import {
  AutoConvertPriceWithUnit,
  convertPriceOnString,
} from "common/priceConvert";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import IncludedFee from "components/molecules/IncludedFee";

import styles from "./Index.module.scss";

const CardBankFee = ({ data }) => {
  return (
    <div className="shadow-bbc flex h-full flex-col justify-between rounded-3xl bg-white py-10 px-7 text-center">
      <p className="mb-10 text-2xl font-semibold leading-9 text-bbc-brand-700 ">
        {data.title}
      </p>
      <p className={`${styles.fee}`}>
        {AutoConvertPriceWithUnit(data.fee, 1)}
        {data.haveNote && <span>*</span>}
      </p>
      {data.note && (
        <p
          className="mt-10 grow"
          dangerouslySetInnerHTML={{ __html: convertPriceOnString(data.note) }}
        ></p>
      )}
    </div>
  );
};

const OpenBankAccount = ({ data, country, title }) => {
  return (
    <div id="banking_options">
      <div className="container">
        <div className="">
          <Title
            className="bbc-title mb-6 text-center capitalize"
            text={title ? title : `Open a Bank Account for ${country} Company `}
          />
          <p
            className="m-auto w-5/6 text-center"
            dangerouslySetInnerHTML={{
              __html:
                data.note ||
                "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply.",
            }}
          />
        </div>
      </div>
      <div className="relative overflow-hidden pt-10 pb-10 lg:pb-20">
        <div className="container relative z-20">
          <div className="row justify-center">
            {data.bank_fee?.length > 0 &&
              data.bank_fee?.map((item, index) => (
                <div
                  key={index}
                  className="col-12 mt-6 first:mt-0 md:col-6 md:mt-0 lg:col-5 xl:col-4"
                >
                  <CardBankFee data={item} />
                </div>
              ))}
          </div>
        </div>
        {data.noteBottom && (
          <div className="container">
            <p
              className="relative z-20 m-auto mt-6 w-5/6 text-center lg:mt-10"
              dangerouslySetInnerHTML={{
                __html:
                  data.noteBottom ||
                  "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply.",
              }}
            />
          </div>
        )}
        <Img
          src="/assets/images/wave/top_bg-wave.png"
          width={1920}
          height={125}
          className="w-full"
          wrapper={{
            className: "w-full absolute top-20 left-0 right-0 z-10 ",
          }}
          alt="Wave top"
        />
        <div className={`${styles.waveTop}`}></div>
      </div>
      <div className="pt-10:pt-20 bg-bbc-package">
        <div className="container">
          <IncludedFee data={data.included} />
        </div>
      </div>
      <div className="relative">
        <div className=" absolute hidden h-1/2 w-full bg-bbc-package md:block"></div>
        <Img
          src="/assets/images/wave/bottom-wave.png"
          width={1920}
          height={140}
          className="w-full"
          wrapper={{ className: "absolute w-full top-1/2 md:block" }}
          alt="Wave bottom"
        />
      </div>
    </div>
  );
};

export default OpenBankAccount;
